import React from 'react';
import { Button } from './ui/button';
import { Phone } from 'lucide-react';
import { toast } from '../hooks/use-toast';

// Opens the phone's native dialer with the contact's real number — a real
// phone call placed by the OS, not an in-app simulation.
const PrivateCallButton = ({ contactName, contactNumber, userType = 'user' }) => {
  const handleCall = () => {
    if (!contactNumber) {
      toast({
        title: 'Number unavailable',
        description: `${contactName || 'Contact'}'s phone number isn't available yet.`,
        variant: 'destructive',
      });
      return;
    }
    window.location.href = `tel:${contactNumber}`;
  };

  return (
    <Button
      size="icon"
      className="rounded-full bg-green-600 hover:bg-green-700"
      onClick={handleCall}
      data-testid="call-btn"
      title={`Call ${contactName || (userType === 'user' ? 'driver' : 'customer')}`}
    >
      <Phone className="w-5 h-5" />
    </Button>
  );
};

export default PrivateCallButton;
